{
  "validation": "Validation failed",
  "forbidden": "Access denied",
  "unauthorized": "Unauthorized",
  "notFound": "Resource not found",
  "duplicate": "Resource already exists",
  "business": "Business rule violation",
  "internal": "Internal server error",
  "tenant": "Cross-tenant access denied",
  "invalidToken": "Invalid or expired token",
  "subscriptionInactive": "Subscription inactive",
  "planLimitExceeded": "Plan limit exceeded",
  "invalidCredentials": "Invalid email or password",
  "networkError": "Network error. Please try again.",
  "sessionExpired": "Your session has expired. Please sign in again.",
  "saveFailed": "Failed to save",
  "updateFailed": "Failed to update",
  "deleteFailed": "Failed to delete",
  "approvalFailed": "Approval action failed",
  "permissionDenied": "Permission denied",
  "loadCompaniesFailed": "Failed to load companies",
  "loadDisplaySettingsFailed": "Failed to save display settings"
}
